import { ProductPreviewCard } from "@/components/cards/product-preview-card";
import { TipCard } from "@/components/cards/tip-card";
import { getProfile } from "@/infrastructure/services/profileService";
import { Loading } from "@uigovpe/components";
import { useEffect, useState } from "react";
import ProductFormCard from "./(components)/product-form-card";
import { defaultProductValues, type ProductFormValues } from "./types";

const tips = [
  "Use fotos nítidas e bem iluminadas",
  "Escolha categorias e subcategorias corretas",
  "Adicione palavras-chave relacionadas ao produto",
  "Descreva os benefícios e diferenciais",
];

export default function AddProducts() {
  const [preview, setPreview] =
    useState<ProductFormValues>(defaultProductValues);
  const [businessName, setBusinessName] = useState("");
  const [isLoadingCategories, setIsLoadingCategories] = useState(true);
  useEffect(() => {
    getProfile()
      .then((profile) => setBusinessName(profile.titulo ?? ""))
      .catch(() => undefined);
  }, []);
  return (
    <main className="min-h-0! w-full! min-w-0! p-5!">
      {isLoadingCategories && (
        <div className="flex! min-h-[320px]! w-full! items-center! justify-center!" role="status" aria-live="polite" aria-label="Carregando categorias">
          <Loading />
          <span className="sr-only">Carregando categorias...</span>
        </div>
      )}
      <div className={`${isLoadingCategories ? "hidden!" : "flex!"} w-full! items-start! gap-5!`}>
        <div className="min-w-0! flex-1! lg:flex-[2.3]!">
          <ProductFormCard onValuesChange={setPreview} onCategoriesLoadingChange={setIsLoadingCategories} />
        </div>
        <aside className="hidden! flex-[0.7]! pt-[60px]! lg:block!">
          <div className="sticky! top-5! ml-auto! flex! w-full! max-w-[360px]! flex-col! items-stretch! gap-5!">
            <ProductPreviewCard
              data={{
                name: preview.name,
                description: preview.description,
                mainImageUrl: preview.mainImage?.url,
                keywords: preview.keywords,
                category: preview.categoryLabel,
                subcategory: preview.subcategoryLabel,
                businessName,
              }}
            />
            <TipCard
              variant="checklist"
              title="Dica para você"
              description="Preencha as informações principais para exibir seu produto ou serviço na vitrine pública."
              items={tips}
              className="w-full!"
            />
          </div>
        </aside>
      </div>
    </main>
  );
}
